export const SET_INIT_CVW = "SET_INIT_CVW";
export const SET_ERROR = "SET_ERROR";
export const INIT_CVW_CONTENT = "INIT_CVW_CONTENT";
export const SET_STEPPER_STATUS = "SET_STEPPER_STATUS";
export const SET_CURRENT_STEP = "SET_CURRENT_STEP";
export const SET_USER_CVS_NUMBER = "SET_USER_CVS_NUMBER";
export const SET_USER_REGISTER_SMART_ALERTS = "SET_USER_REGISTER_SMART_ALERTS";
